// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"UserPayments_datepicker__LqxyR","root":"UserPayments_root__5XpAE","paper":"UserPayments_paper__3qu30"};